<div [id]="htmlId()" [style.display]="isVisible() ? 'block' : 'none'">
  <span [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']" [style]="textStyle()">{{
    properties.text
  }}</span>
</div>
